// extracted by mini-css-extract-plugin
module.exports = {"heading":"info_heading__nxOdV","content":"info_content__3WMd-","sending":"info_sending__1-9fK"};